import { render, staticRenderFns } from "./FilterAssocModal.vue?vue&type=template&id=1635c942"
import script from "./FilterAssocModal.vue?vue&type=script&lang=js"
export * from "./FilterAssocModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports